import { render, staticRenderFns } from "./OcorrenciasEdit.vue?vue&type=template&id=17635e94&scoped=true&"
import script from "./OcorrenciasEdit.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17635e94",
  null
  
)

export default component.exports